import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const MPMC_AddressingModes = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Addressing Modes"
      videos={[
        "https://www.youtube.com/embed/vLiGL9L4m-k", // Addressing Modes of 8051 Microcontroller
      ]}
      takeaways={[
        { text: "Be prepared for direct questions on explaining all addressing modes." },
        { text: "Understand Immediate, Register, Direct, Indirect, and Indexed addressing modes." },
        { text: "Identify the addressing mode from a given piece of code." },
      ]}
      questions={[]} // No specific previous questions provided
      exampleVideos={[]} // No example question videos provided
    />
  );
}

export default MPMC_AddressingModes;
